import React from "react";

import "../../Infrastructure/chartSetup";

import KpiCards from "./KpiCards";
import TrendChart from "./TrendChart";
import BreedChart from "./BreedChart";
import ReceivableAging from "./ReceivableAging";
import TopDebtors from "./TopDebtors";
import RecentActivities from "./RecentActivities";
import MemberTanks from "./MemberTanks";
import UnionInventory from "./UnionInventory";

/**
 * İstatistikler ekranının kart düzeni — frontend İstatistikler sayfası ve
 * admin'deki "Birlik Özeti" (TOB) aynı düzeni kullanır.
 *
 * Kartlar veriyi kendileri çeker (useStatistics); hangi uçtan çekecekleri
 * StatisticsEndpointContext ile değiştirilebilir. `onNavigate` verilmezse
 * kartlardaki "Rapora git / Tümü" bağlantıları gizlenir.
 */
const StatisticsBoard = ({ onNavigate }) => (
  <div className="fdash">
    <KpiCards />

    <div className="fdash__charts">
      <TrendChart />
      <BreedChart />
    </div>

    <div className="fdash__split">
      <ReceivableAging onNavigate={onNavigate} />
      <TopDebtors onNavigate={onNavigate} />
    </div>

    {/* Son İşlemler ile tank kartları aynı satırda: sağ sütunda birliğin kendi
        envanteri (Birlik Tankları) ve Üye Tankları alt alta */}
    <div className="fdash__split">
      <RecentActivities />

      <div style={styles.stack}>
        <UnionInventory />
        <MemberTanks />
      </div>
    </div>
  </div>
);

// Sağ sütun: kartlar alt alta, .fdash ile aynı aralık.
const styles = {
  stack: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    minWidth: 0,
  },
};

export default StatisticsBoard;
